import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { SelectOption } from "./types";

dayjs.extend(utc);

export const METRIC_ONE_VALUE = "Metric 1";
export const METRIC_THREE_VALUE = "Metric 3";

export const METRIC_OPTIONS: SelectOption[] = [
  { name: METRIC_ONE_VALUE, value: METRIC_ONE_VALUE },
  { name: "Metric 2_Task Level", value: "Metric 2_Task Level" },
  { name: "Metric 3", value: "Metric 3" },
  { name: "Metric 4_Account Level", value: "Metric 4_Account Level" },
  { name: "Metric 4_Procedure Change Log", value: "Metric 4_Procedure Change Log" },
  { name: "Metric 5", value: "Metric 5" },
  { name: "Metric 6", value: "Metric 6" },
];

export const QUARTER_OPTIONS: SelectOption[] = [
  { name: "Q1", value: "Q1" },
  { name: "Q2", value: "Q2" },
  { name: "Q3", value: "Q3" },
  { name: "Q4", value: "Q4" },
];

export const MONTH_OPTIONS: SelectOption[] = [
  { name: "Jan", value: "01" },
  { name: "Feb", value: "02" },
  { name: "Mar", value: "03" },
  { name: "Apr", value: "04" },
  { name: "May", value: "05" },
  { name: "Jun", value: "06" },
  { name: "Jul", value: "07" },
  { name: "Aug", value: "08" },
  { name: "Sep", value: "09" },
  { name: "Oct", value: "10" },
  { name: "Nov", value: "11" },
  { name: "Dec", value: "12" },
];

export const ACCEPTED_FILE_EXTENSIONS = [".xlsx", ".xls", ".xlsm", ".csv"];
export const ACCEPTED_FILE_TYPES = ACCEPTED_FILE_EXTENSIONS.join(",");

export const MAX_FILE_SIZE_MB = 300;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const DATA_START_YEAR = "2018";
export const DATA_START_MONTH = "01";
export const DATA_START_QUARTER = "Q1";

export const NO_FILE_SELECTED_MESSAGE = "No file chosen";
export const INVALID_FILE_FORMAT_MESSAGE =
  "The file format is not supported. Please upload an Excel or CSV file (.xlsx, .xls, .xlsm, or .csv).";

// Returns the current date in UTC+8 (midnight is the day boundary).
export const getCurrentUTC8Date = (): Date => {
  const nowUtc8 = dayjs.utc().add(8, "hour");
  return new Date(nowUtc8.year(), nowUtc8.month(), nowUtc8.date(), nowUtc8.hour());
};

// Change this value to simulate a different current date during local development.
// Must be restored to `getCurrentUTC8Date()` before committing.
export const NOW: Date = getCurrentUTC8Date(); // new Date("2026-04-01T00:00:00"); //new Date("2026-03-31T12:00:00");
console.log("NOW", NOW);
